import type { SVGProps } from 'react'

interface CerradoBiomeIconProps extends SVGProps<SVGSVGElement> {}

export function CerradoBiomeIcon(props: CerradoBiomeIconProps) {
  return (
    <svg
      width={40}
      height={32}
      viewBox="0 0 40 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.898 19.844a10.148 10.148 0 01-5.305 1.476 11.946 11.946 0 01-4.559-.943 9.257 9.257 0 00-1.703 5.373v4.914a1.334 1.334 0 01-1.421 1.333 1.363 1.363 0 01-1.245-1.375V28.55l-6.436-6.436a8.747 8.747 0 01-2.99.552 7.632 7.632 0 01-3.985-1.111C1.623 19.347-.332 14.27.046 7.966A1.333 1.333 0 011.3 6.713C7.603 6.34 12.681 8.289 14.88 11.92a7.666 7.666 0 011.075 4.746.666.666 0 01-1.148.405l-3.2-3.35a1.333 1.333 0 00-1.884 1.885l8.979 9.207c.01-.13.021-.26.035-.388a11.424 11.424 0 013.106-6.576l8.43-8.908a1.334 1.334 0 00-1.885-1.887l-8.165 8.636a.666.666 0 01-1.13-.29c-.79-2.913-.441-5.813 1.067-8.303C23.136 2.185 30.06-.445 38.687.062a1.333 1.333 0 011.253 1.253c.5 8.627-2.13 15.553-7.042 18.529z"
        fill="currentColor"
      />
    </svg>
  )
}
